/* eslint-disable no-underscore-dangle */
import forEach from 'lodash/forEach';
import reduce from 'lodash/reduce';
import get from 'lodash/get';

import JPlayerFactory from './jplayer/JPlayerFactory';
import HlsJsPlayerFactory from './hlsjs/HlsJsPlayerFactory';
import WindowsMediaPlayerFactory from './wmp/WindowsMediaPlayerFactory';
import WebMediaPlayerFactory from './webmediaplayer/WebMediaPlayerFactory';

import players from './constants/players';
import debug from '../debugger';

export default class PlayerCache {
  constructor(configuration, queueSize = 3) {
    this.queueSize = queueSize;
    this.cache = {
      [players.wmp]: {
        queue: [],
        factory: new WindowsMediaPlayerFactory(
          get(configuration, 'blankMp3Url'),
        ),
      },
    };

    if (configuration.isWebMediaPlayerEnabled) {
      this.cache[players.webmediaplayer] = {
        queue: [],
        factory: new WebMediaPlayerFactory(
          get(configuration, 'isIcyMetadataEnabled'),
        ),
      };

      this.cache[players.hlsjs] = {
        queue: [],
        factory: new WebMediaPlayerFactory(
          get(configuration, 'isIcyMetadataEnabled'),
          true,
        ),
      };
    } else {
      this.cache[players.jplayer] = {
        queue: [],
        factory: new JPlayerFactory(),
      };

      this.cache[players.hlsjs] = {
        queue: [],
        factory: new HlsJsPlayerFactory(
          get(configuration, 'resources.fetchHlsJsLibrary'),
        ),
      };
    }

    // Load the cache when PlayerCache is instantiated.
    this._load();
  }

  get allPlayers() {
    return reduce(
      this.cache,
      (allPlayers, playerConfig) => allPlayers.concat(playerConfig.queue),
      [],
    );
  }

  setPlayer(name) {
    const config = this.cache[name];
    if (!config) {
      return;
    }

    if (config.queue.length >= this.queueSize) {
      return;
    }
    try {
      const player = config.factory.createPlayer();
      if (!player) {
        return;
      }
      config.queue.push(player);
    } catch (ex) {
      debug.log('Could not create player ' + name, ex);
    }
  }

  async getPlayer(name) {
    const config = this.cache[name];
    if (!config) {
      return null;
    }
    const player = config.queue.shift();
    if (!player) {
      return null;
    }

    try {
      // Asynchronous player initialization routines are called
      // here when we get players from cache so that the setting
      // of the players in the cache are synchronous operations.
      await player.init();
      return player;
    } catch (ex) {
      debug.log('Could not initialize cached player ' + player, ex);
      return null;
    }
  }

  _load() {
    forEach(this.cache, (playerConfig, playerName) => {
      for (let i = 0; i < this.queueSize; i++) {
        this.setPlayer(playerName);
      }
    });
  }
}
